export const APP_NAME = 'Azalea';
export const APP_TAGLINE = 'Tap a picture. Say it out loud.';
export const APP_TAGLINE_ALT = 'Picture communication, made personal.';

const envOrigin = import.meta.env.VITE_SITE_ORIGIN as string | undefined;
const envBase = import.meta.env.VITE_AZALEA_BASE as string | undefined;

export const SITE_ORIGIN = envOrigin ?? 'https://giggenie.app';
/** `/azalea` on giggenie.app; empty string on azaleaspeak.com (root paths). */
export const AZALEA_BASE = (envBase ?? '/azalea').replace(/\/$/, '');

export function azaleaPath(subpath = ''): string {
  const suffix = subpath ? (subpath.startsWith('/') ? subpath : `/${subpath}`) : '';
  if (!AZALEA_BASE) return suffix || '/';
  return `${AZALEA_BASE}${suffix}`;
}

export const SHARE_DESCRIPTION =
  'Tap a picture. Say it out loud. Free picture communication for kids, teens, and adults.';
export const SHARE_IMAGE = `${SITE_ORIGIN}/azalea/screenshots/IMG_4455-2.PNG`;
export const SHARE_TITLE = 'Azalea: Tap a picture. Say it out loud.';
export const SHARE_URL = `${SITE_ORIGIN}${azaleaPath()}`;
export const PRIVACY_URL = `${SITE_ORIGIN}${azaleaPath('privacy')}`;
export const TERMS_URL = `${SITE_ORIGIN}${azaleaPath('terms')}`;
export const SUPPORT_PAGE_URL = `${SITE_ORIGIN}${azaleaPath('support')}`;
export const SUPPORT_URL = 'https://github.com/AnwaarHimself/azalea/issues';
export const APP_STORE_URL = 'https://apps.apple.com/app/idXXXXXXXXX';
export const APP_VERSION = '1.0.0';
export const DEVELOPER = 'HumbleStack';
export const BUNDLE_ID = 'com.humblestack.azalea';

/** Public asset base — files live in public/azalea/ */
export const ASSET = (path: string) => `/azalea/${path}`;

export const GALLERY_SCREENSHOTS: { src: string; alt: string }[] = [
  {
    src: ASSET('screenshots/IMG_4455-2.PNG'),
    alt: 'Azalea home with favorites, routines, and categories',
  },
  {
    src: ASSET('screenshots/IMG_4457-2.PNG'),
    alt: 'Morning routine with brush teeth, bathroom, and water',
  },
  {
    src: ASSET('screenshots/IMG_4456-2.PNG'),
    alt: 'Bedtime routine with bath, bathroom, and reading',
  },
  {
    src: ASSET('screenshots/IMG_4452.PNG'),
    alt: 'Fun things category: play, TV, books, and music',
  },
  {
    src: ASSET('screenshots/hero-teens-feelings.png'),
    alt: 'Teen feeling portraits for emotional communication',
  },
  {
    src: ASSET('screenshots/IMG_4454.PNG'),
    alt: 'Create custom photo buttons in parent settings',
  },
  {
    src: ASSET('screenshots/IMG_4453.PNG'),
    alt: 'Parent settings, voice picker, and accessibility options',
  },
  {
    src: ASSET('screenshots/IMG_4446.PNG'),
    alt: 'Play Zone colors sensory break',
  },
];
